<template>
    <v-layout row wrap>
        <v-flex xs12 sm6 pr-1>
            <v-text-field
                class="body-2"
                type="email"
                :value="value"
                :outlined="outlined"
                :append-icon="appendIcon"
                :name="metadata.name"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                validate-on-blur
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :maxlength="maxLength"
                counter
                :rules="[
                    !isRequired || requiredField(),
                    !getSendByEmail || requiredField(),
                    v => !v || getFormRule('email')(v)
                ]"
                data-testid="email-input"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="debouncedInput"
            />
        </v-flex>
        <v-flex xs12 sm6 pl-1>
            <v-text-field
                v-model="confirmEmail"
                class="body-2"
                type="email"
                outlined
                name="confirmEmail"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :append-icon="appendIcon"
                :label="(isRequired ? '* ' + $t('form.confirmEmail') : $t('form.confirmEmail'))"
                :placeholder="$t('appt.placeholder.confirmEmail')"
                validate-on-blur
                :rules="[
                    v => !confirmEmailCheck() ? $t('appt.errors.emailNoMatch') : true
                ]"
                data-testid="confirm-email-input"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { debounce, find, get, replace, trim } from 'lodash';
import { MetadataEnum } from '@/enums';

export default {
    name: 'email',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        otherMetadata: { type: Array, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    data() {
        return {
            debouncedInput: undefined,
        };
    },
    created() {
        this.debouncedInput = debounce(this.emitValue, 500);
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getSendByEmail: 'metadataForm/getSendByEmail',
        }),
        appendIcon() {
            return this.withIcon ? 'far fa-envelope' : '';
        },
        confirmEmail: {
            get: function() { return this.$store.getters['metadataForm/getConfirmEmail']; },
            set: function(value) { this.$store.commit('metadataForm/SET_CONFIRM_EMAIL', value); },
        },
        covidScreeningPreferredCommunicationByEmailMetadata() {
            return this.otherMetadata &&
                find(this.otherMetadata, ['metadata', MetadataEnum.COVID_SCREENING_PREFERRED_COMMUNICATION]);
        },
        covidScreeningConsentReceiveResultByEmailSmsMetadata() {
            return this.otherMetadata &&
                find(this.otherMetadata, ['metadata', MetadataEnum.COVID_SCREENING_CONSENT_RECEIVE_RESULT_BY_EMAIL_SMS], 0);
        },
        isRequiredByOtherMetadata() {
            const preferredCommunication = get(this.covidScreeningPreferredCommunicationByEmailMetadata, 'value');
            const preferredCommunicationOptions = this.$i18n.t('covidScreeningMetadataLang.covidScreeningPreferredCommunication.dropDown');
            return !!get(this.covidScreeningConsentReceiveResultByEmailSmsMetadata, 'value') || preferredCommunication === preferredCommunicationOptions[0];
        },
        isRequired() {
            return this.required || this.isRequiredByOtherMetadata;
        },
        maxLength() {
            return this.metadata && this.metadata.rules && this.metadata.rules.maxLength;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', replace(trim(value || ''), /\s+/g, ''));
        },

        /**
         * @description Validate email and confirm email
         * @returns {boolean}
         */
        confirmEmailCheck() {
            return !this.value ||
                this.value === this.confirmEmail;
        },
    },
};
</script>
